module.exports = __webpack_public_path__ + "static/images/dialog-top-bg.02ff1b2.png";